import React from 'react'
import { Switch, Route } from "react-router-dom";
import Q3 from './QuestionStep/Q3'
import Q2 from './QuestionStep/Q2'
import Q1 from './QuestionStep/Q1'
import Q4 from './QuestionStep/Q4'
import Q5 from './QuestionStep/Q5'
import Q6 from './QuestionStep/Q6'
import Q7 from './QuestionStep/Q7'
import Q8 from './QuestionStep/Q8'
import Middle from './Middle'
import Q9 from './QuestionStep/Q9'
import Q10 from './QuestionStep/Q10'
import Q11 from './QuestionStep/Q11'
import Q12 from './QuestionStep/Q12'
import CulcRes from './CulcRes'
import Result from './QuestionStep/Result'
import ResultShare from './ResultShare'



function Questions() {
    return (
        <div className="question-container">
            <Switch>
                <Route path="/Q/1" exact component={Q1} />
                <Route path="/Q/2" exact component={Q2} />
                <Route path="/Q/3" exact component={Q3} />
                <Route path="/Q/4" exact component={Q4} />
                <Route path="/Q/5" exact component={Q5} />
                <Route path="/Q/6" exact component={Q6} />
                <Route path="/Q/7" exact component={Q7} />
                <Route path="/Q/8" exact component={Q8} />
                <Route path="/Middle" exact component={Middle} />
                <Route path="/Q/9" exact component={Q9} />
                <Route path="/Q/10" exact component={Q10} />
                <Route path="/Q/11" exact component={Q11} />
                <Route path="/Q/12" exact component={Q12} />
                <Route path="/CulcRes" exact component={CulcRes} />
                <Route path="/Q/result" exact component={Result} />            
                <Route path="/ResultShare" exact component={ResultShare} />            
            </Switch>

        </div>
    )
}



export default Questions

